import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

/**
 * Hook to fetch admin dashboard statistics
 * Uses database function for optimal performance with 1000+ farms
 */
export const useAdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAdminStats();
  }, []);

  const loadAdminStats = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('🔧 Loading admin dashboard stats...');

      // Call database function - single query gets all stats
      const { data, error: rpcError } = await supabase
        .rpc('get_admin_dashboard_stats');

      if (rpcError) {
        console.error('❌ Error loading admin stats:', rpcError);
        throw rpcError;
      }

      console.log('✅ Admin stats loaded:', data);
      setStats(data);
      setLoading(false);

    } catch (err) {
      console.error('❌ Error in loadAdminStats:', err);
      setError(err);
      setLoading(false);
    }
  };

  return {
    stats,
    loading,
    error,
    refresh: loadAdminStats
  };
};

export default useAdminDashboard;
